export default __webpack_public_path__ + "static/media/default-team-logo.051956f1.png";